import React from 'react';
import styled from 'styled-components/macro';
import { Body, Heading } from '@cognite/cogs.js';

type CollectionHeaderProps = {
  collectionCount: number;
};

export const CollectionHeader = ({
  collectionCount,
}: CollectionHeaderProps) => {
  return (
    <StyledWrapper>
      <StyledHeading level={3}>Data Consistency</StyledHeading>
      <StyledInlineFlex>
        <Heading level={4}>Collections:</Heading>
        <StyledBodyGroup size="medium">
          <StyledSpanBold>{collectionCount}</StyledSpanBold>{' '}
          {collectionCount !== 1 ? 'collections' : 'collection'}
        </StyledBodyGroup>
      </StyledInlineFlex>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  padding: 1.5rem 2rem 0.5rem;
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 0.5rem;
`;

const StyledInlineFlex = styled.div`
  display: inline-flex;
  align-items: baseline;
  gap: 1rem;
`;

const StyledBodyGroup = styled(Body)`
  display: inline-flex;
  gap: 0.25rem;
`;

const StyledSpanBold = styled.span`
  font-weight: 700;
`;
